// extracted by mini-css-extract-plugin
export default {"page":"NotFoundPage_page__2nr8D","title":"NotFoundPage_title__zb25T"};